<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <guides-title-card />
        </b-col>
        <b-col cols="12">
          <guides-task-type-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <guides-departments-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <guides-teams-card />
        </b-col>
        <b-col cols="12">
          <guides-description-card />
        </b-col>
        <b-col cols="12">
          <guides-status-card />
        </b-col>
      </b-row>
    </b-card>
    <guide-steps v-if="itemData.id" />
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import GuidesTitleCard from '@/views/Guides/Elements/TitleCard.vue'
import GuidesDescriptionCard from '@/views/Guides/Elements/DescriptionCard.vue'
import GuidesTaskTypeCard from '@/views/Guides/Elements/TaskTypeCard.vue'
import GuidesStatusCard from '@/views/Guides/Elements/StatusCard.vue'
import GuidesDepartmentsCard from '@/views/Guides/Elements/DepartmentsCard.vue'
import GuidesTeamsCard from '@/views/Guides/Elements/TeamsCard.vue'
import GuideSteps from '@/views/Guides/Components/GuideSteps.vue'

export default {
  name: 'GuidesItemForm',
  components: {
    GuidesTitleCard,
    GuidesDescriptionCard,
    GuidesTaskTypeCard,
    GuidesStatusCard,
    GuidesDepartmentsCard,
    GuidesTeamsCard,
    GuideSteps,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['guides/dataItem']
    },
  },
}
</script>
